import C0822Validator from 'shared/ncts/p6/conditions/C0822'
import C0823Validator from 'shared/ncts/p6/conditions/C0823'
import C0839Validator from 'shared/ncts/p6/conditions/C0839'
import C0101Validator from 'shared/ncts/p6/conditions/C0101'
import C0587Validator from 'shared/ncts/p6/conditions/C0587'
import C0598Validator from 'shared/ncts/p6/conditions/C0598'
import C0670Validator from 'shared/ncts/p6/conditions/C0670'
import C0055Validator from 'shared/ncts/p6/conditions/C0055'
import NC9043Validator from 'shared/ncts/FI/NC9043'
import NC007Validator from 'shared/ncts/SK/NC007'
import C0710Validator from 'shared/ncts/p6/conditions/C0710'
import C0394Validator from 'shared/ncts/p6/conditions/C0394'
import C0671Validator from 'shared/ncts/p6/conditions/C0671'
import NC0035Validator from 'shared/ncts/FI/NC0035'
import NC9012Validator from 'shared/ncts/FI/NC9012'
import C0505Validator from 'shared/ncts/p6/conditions/C0505'
import C0382Validator from 'shared/ncts/p6/conditions/C0382'
import C0806Validator from 'shared/ncts/p6/conditions/C0806'
import C0586Validator from 'shared/ncts/p6/conditions/C0586'
import C0019Validator from 'shared/ncts/p6/conditions/C0019'
import C0024Validator from 'shared/ncts/p6/conditions/C0024'
import C0939Validator from 'shared/ncts/p6/conditions/C0939'
import C0936Validator from 'shared/ncts/p6/conditions/C0936'
import C0935Validator from 'shared/ncts/p6/conditions/C0935'
import C0601Validator from 'shared/ncts/p6/conditions/C0601'
import C0945Validator from 'shared/ncts/p6/conditions/C0945'
import C0405Validator from 'shared/ncts/p6/conditions/C0405'
import C0252Validator from 'shared/ncts/p6/conditions/C0252'
import C0506Validator from 'shared/ncts/p6/conditions/C0506'
import CustomValidators from 'shared/ncts/validation'
import C0931Validator from 'shared/ncts/p6/conditions/C0931'
import C0932Validator from 'shared/ncts/p6/conditions/C0932'
import C0053Validator from 'shared/ncts/p6/conditions/C0053'
import C0543Validator from 'shared/ncts/p6/conditions/C0543'
import C0542Validator from 'shared/ncts/p6/conditions/C0542'
import C0934Validator from 'shared/ncts/p6/conditions/C0934'
import C0532Validator from 'shared/ncts/p6/conditions/C0532'
import C0937Validator from 'shared/ncts/p6/conditions/C0937'
import C0940Validator from 'shared/ncts/p6/conditions/C0940'
import C0071Validator from 'shared/ncts/p6/conditions/C0071'
import C0826Validator from 'shared/ncts/p5/conditions/C0826'
import C0031Validator from 'shared/ncts/p6/conditions/C0031'
import C0144Validator from 'shared/ncts/p6/conditions/C0144'
import C0941Validator from 'shared/ncts/p6/conditions/C0941'
import NA60Validator from 'shared/ncts/EE/NA60'
import NA61Validator from 'shared/ncts/EE/NA61'
import NA62Validator from 'shared/ncts/EE/NA62'
import C0944Validator from 'shared/ncts/p6/conditions/C0944'
import { hasText } from 'shared/lib/common-util'
import { NctsCountry, supportsPreLodgedDeclaration } from 'config'
import { FieldRequirementResolverContext } from '../types'
import { createFieldRequirementGetter, matchServerRequirement } from '../../../resolverFactory'
import {
  FieldRequirement,
  FieldRequirementEnvironment,
  FieldRequirementResolverMap, forbidden, optional, required,
  toFieldRequirement,
} from '../../../../../../models/fieldRules'
import C0003Validator from '../../../../../../../../shared/ncts/p6/conditions/C0003'
import C0001Validator from '../../../../../../../../shared/ncts/p6/conditions/C0001'
import { isConsigneePresent, isConsignorPresent } from '../../../../../../../../shared/ncts/common/types'
import C0250Validator from '../../../../../../../../shared/ncts/p5/conditions/C0250'
import resolveEffectiveRequirement from '../../../resolveEffectiveRequirement'
import C0186Validator from '../../../../../../../../shared/ncts/p6/conditions/C0186'
import C0036Validator from '../../../../../../../../shared/ncts/p6/conditions/C0036'
import C0037Validator from '../../../../../../../../shared/ncts/p6/conditions/C0037'
import C0409Validator from '../../../../../../../../shared/ncts/p6/conditions/C0409'

function ruleForAdditionalDeclarationType(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return supportsPreLodgedDeclaration(ctx.country as NctsCountry) ? 'required' : 'forbidden'
}

function ruleForReferenceNumberUCR(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.country === 'FI' ? 'required' : 'optional'
}

function ruleForContainerIndicator(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0822Validator.validateContainerIndicatorRequirement(ctx))
}

function ruleForTransportEquipment(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0823Validator.validateTransportEquipmentRequirement(ctx))
}

function ruleForLimitDate(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0839Validator.validateLimitDateRequirement(ctx))
}

function ruleForBorderModeOfTransport(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0601Validator.validateModeOfTransportAtTheBorderRequirement(ctx))
}

function ruleForLoading(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (ctx.isOptIn) {
    return toFieldRequirement(C0405Validator.validatePlaceOfLoadingRequirement(ctx))
  }

  return toFieldRequirement(C0409Validator.validatePlaceOfLoadingRequirement(ctx))
}

function ruleForUnloading(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0945Validator.validatePlaceOfUnloadingRequirement(ctx))
}

function ruleForAuthorisations(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0101Validator.validateAuthorisationRequirement(ctx.reducedDatasetIndicator))
}

function ruleForCustomsOfficesOfTransitExit(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0587Validator.validateTransitExitCustomsOfficeRequirement(ctx))
}

function ruleForTransitCustomsOfficeArrivalDateTime(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0598Validator.validateTransitOfficeDateTimeRequirement(ctx))
}

function ruleForTransitCustomsOfficeEntryIndicator(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0031Validator.validateCustomsOfficeOfTransitEntryIndicatorRequirement(ctx))
}

function ruleForTransitCustomsOfficeReEntryIndicator(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const entryIndicatorRequirement = ruleForTransitCustomsOfficeEntryIndicator(env)
  if (entryIndicatorRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0144Validator.validateCustomsOfficeOfTransitReEntryIndicatorRequirement(ctx))
}

function ruleForGoodsReferences(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0670Validator.validateGoodsReferenceRequirement(ctx))
}

function ruleForContainerIdentificationNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0055Validator.isContainerIdentificationNumberRequired(ctx))
}

function ruleForLocationOfGoods(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.locationOfGoods?.typeOfLocation) return 'required'

  if (ctx.country === 'FI') {
    return toFieldRequirement(NC9043Validator.validateLocationOfGoodsRequirement(ctx))
  }

  if (ctx.country === 'SK') {
    return toFieldRequirement(NC007Validator.validateLocationOfGoodsRequirement(ctx))
  }

  return toFieldRequirement(C0710Validator.validateLocationOfGoodsRequirement(ctx))
}

function ruleForLocationOfGoodsAuthorisationNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0394Validator.validateAuthorisationNumberRequirement(ctx))
}

function ruleForLocationOfGoodsAdditionalIdentifier(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'
  return toFieldRequirement(C0671Validator.validateAdditionalIdentifierRequirement(ctx))
}

function ruleForLocationOfGoodsEconomicOperatorIdentificationNumber(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  if (ctx.country === 'FI') {
    return toFieldRequirement(NC0035Validator.validateEconomicOperatorRequirement(ctx))
  }

  return toFieldRequirement(C0394Validator.validateEconomicOperatorRequirement(ctx))
}

function ruleForLocationOfGoodsGnss(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0394Validator.validateGnssRequirement(ctx))
}

function ruleForLocationOfGoodsQualifierOfIdentification(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'

  return ctx.locationOfGoods?.typeOfLocation ? 'required' : 'forbidden'
}

function ruleForLocationOfGoodsContactPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification') ?? 'optional'
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateContactPersonRequirement(ctx))
}

function ruleForLocationOfGoodsAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') {
    return toFieldRequirement(NC9012Validator.validateAddressRequirement(ctx))
  }

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification') ?? 'optional'
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateAddressRequirement(ctx))
}

function ruleForLocationOfGoodsAddressPart(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (!ctx.locationOfGoods?.address) return 'forbidden'

  return ruleForLocationOfGoodsAddress(env)
}

function ruleForLocationOfGoodsAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (!ctx.locationOfGoods?.address) return 'forbidden'

  const parentRequirement = ruleForLocationOfGoodsAddress(env)
  if (parentRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0505Validator.validatePostcodeRequirement(ctx?.locationOfGoods?.address?.country))
}

function ruleForLocationOfGoodPostcodeAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification') ?? 'optional'
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validatePostCodeAddressRequirement(ctx))
}

function ruleForLocationOfGoodPostcodeAddressHouseNumber(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  const parentRequirement = ruleForLocationOfGoodPostcodeAddress(env)
  if (parentRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0382Validator.validateHouseNumberRequirement(ctx))
}

function ruleForLocationOfGoodsReferenceNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification') ?? 'optional'
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateCustomsOfficeRequirement(ctx))
}

function ruleForLocationOfGoodsTypeOfLocation(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (env.getFieldRequirement('locationOfGoods') === 'required') return 'required'

  return ctx.locationOfGoods?.typeOfLocation ? 'required' : 'optional'
}

function ruleForLocationOfGoodsUnLocode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification') ?? 'optional'
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateUnLocodeRequirement(ctx))
}

function ruleForConsignee(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const ruleConditions = ctx.serverValidationResult?.ruleConditions

  const requirement = toFieldRequirement(ctx.isOptIn
    ? C0003Validator.validateConsignmentConsigneeRequirement({
      security: ctx.security,
      specificCircumstanceIndicator: ctx.specificCircumstanceIndicator ?? '',
      isConsignmentConsigneePresent: isConsigneePresent(ctx.consignee),
      hasConsignmentAdditionalReference30600: !!ruleConditions?.hasConsignmentAdditionalReference30600,
      hasHouseConsignmentAdditionalReference30600: !!ruleConditions?.hasHouseConsignmentAdditionalReference30600,
    })
    : C0001Validator.validateConsignmentConsigneeRequirement({
      isConsignmentConsigneePresent: isConsigneePresent(ctx.consignee),
      hasConsignmentAdditionalReference30600: !!ruleConditions?.hasConsignmentAdditionalReference30600,
      hasHouseConsignmentAdditionalReference30600: !!ruleConditions?.hasHouseConsignmentAdditionalReference30600,
    }))

  return requirement === 'optional' && isConsigneePresent(ctx.consignee) ? 'required' : requirement
}

function ruleForConsigneeTypeOfPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  const consigneeRequirement = env.getFieldRequirement('consignee') ?? 'optional'
  const requirement = toFieldRequirement(C0934Validator.validateConsignmentTypeOfPersonRequirement(ctx))

  return resolveEffectiveRequirement(consigneeRequirement, requirement)
}

function ruleForConsigneeNameAndAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const consigneeRequirement = env.getFieldRequirement('consignee') ?? 'optional'
  if (consigneeRequirement !== 'required') return consigneeRequirement
  if (ctx.country === 'RO') return consigneeRequirement

  return toFieldRequirement(C0252Validator.validateNameAndAddressRequirement({
    security: ctx.security,
    identificationNumber: ctx.consignee?.identificationNumber,
  }))
}

function ruleForConsigneeAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const addressRequirement = env.getFieldRequirement('consignee.address') ?? 'optional'
  const requirement = toFieldRequirement(ctx.isOptIn
    ? C0506Validator.validateStandardPostcodeRequirement(ctx.consignee?.address?.country ?? '')
    : C0505Validator.validatePostcodeRequirement(ctx.consignee?.address?.country ?? ''))

  return resolveEffectiveRequirement(addressRequirement, requirement)
}

function ruleForConsigneeAddressAddressLine(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consigneeAddressRequirement = env.getFieldRequirement('consignee.address') ?? 'optional'
  const requirement = ctx.isOptIn
    ? toFieldRequirement(C0036Validator.validateConsignmentConsigneeAddressLineRequirement(ctx))
    : 'required'

  return resolveEffectiveRequirement(consigneeAddressRequirement, requirement)
}

function ruleForConsigneeAddressStreet(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consigneeAddressRequirement = env.getFieldRequirement('consignee.address') ?? 'optional'
  const requirement = ctx.isOptIn
    ? toFieldRequirement(C0037Validator.validateConsignmentConsigneeStreetRequirement(ctx))
    : 'forbidden'

  return resolveEffectiveRequirement(consigneeAddressRequirement, requirement)
}

function ruleForConsigneeAddressStreetNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  return env.getFieldRequirement('consignee.address.street') ?? 'optional'
}

function ruleForConsignor(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const requirement = toFieldRequirement(ctx.isOptIn
    ? C0543Validator.validateConsignmentConsignorRequirement(ctx)
    : C0542Validator.validateConsignmentConsignorRequirement(ctx))

  return requirement === 'optional' && isConsignorPresent(ctx.consignor) ? 'required' : requirement
}

function ruleForConsignorContactPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const consignorRequirement = env.getFieldRequirement('consignor') ?? 'optional'
  if (consignorRequirement === 'forbidden') return 'forbidden'

  return ctx.country === 'LT' && hasText(ctx.consignor?.identificationNumber) ? 'required' : 'optional'
}

function ruleForConsignorContactPersonNameAndPhone(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const contactPersonRequirement = env.getFieldRequirement('consignor.contactPerson') ?? 'optional'
  if (contactPersonRequirement === 'forbidden') return 'forbidden'
  if (ctx.country === 'LT' && hasText(ctx.consignor?.identificationNumber)) {
    return 'required'
  }

  return CustomValidators.validateContactPersonNameAndPhoneRequirement(ctx.consignor?.contactPerson) ? 'required' : contactPersonRequirement
}

function ruleForConsignorContactPersonEmail(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  const contactPersonRequirement = env.getFieldRequirement('consignor.contactPerson') ?? 'optional'
  if (contactPersonRequirement === 'forbidden') return 'forbidden'

  return ctx.country === 'LT' && hasText(ctx.consignor?.identificationNumber) ? 'required' : 'optional'
}

function ruleForConsignorTypeOfPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (!ctx.isOptIn) return 'forbidden'

  const consignorRequirement = env.getFieldRequirement('consignor') ?? 'optional'
  const requirement = toFieldRequirement(C0934Validator.validateConsignmentTypeOfPersonRequirement(ctx))

  return resolveEffectiveRequirement(consignorRequirement, requirement)
}

function ruleForConsignorNameAndAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const consignorRequirement = env.getFieldRequirement('consignor') ?? 'optional'
  if (consignorRequirement !== 'required') return consignorRequirement
  if (ctx.country === 'RO') return consignorRequirement

  return toFieldRequirement(ctx.isOptIn
    ? C0252Validator.validateNameAndAddressRequirement({
      security: ctx.security,
      identificationNumber: ctx.consignor?.identificationNumber,
    })
    : C0250Validator.validateNameAndAddressRequirement(ctx.consignor?.identificationNumber))
}

function ruleForConsignorAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const addressRequirement = env.getFieldRequirement('consignor.address') ?? 'optional'
  if (addressRequirement !== 'required') return addressRequirement

  return toFieldRequirement(ctx.isOptIn
    ? C0506Validator.validateStandardPostcodeRequirement(ctx.consignor?.address?.country ?? '')
    : C0505Validator.validatePostcodeRequirement(ctx.consignor?.address?.country ?? ''))
}

function ruleForConsignorAddressAddressLine(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consignorAddressRequirement = env.getFieldRequirement('consignor.address') ?? 'optional'
  const requirement = ctx.isOptIn
    ? toFieldRequirement(C0036Validator.validateConsignmentConsignorAddressLineRequirement(ctx))
    : 'required'

  return resolveEffectiveRequirement(consignorAddressRequirement, requirement)
}

function ruleForConsignorAddressStreet(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consignorAddressRequirement = env.getFieldRequirement('consignor.address') ?? 'optional'
  const requirement = ctx.isOptIn
    ? toFieldRequirement(C0037Validator.validateConsignmentConsignorStreetRequirement(ctx))
    : 'forbidden'

  return resolveEffectiveRequirement(consignorAddressRequirement, requirement)
}

function ruleForConsignorAddressStreetNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  return env.getFieldRequirement('consignor.address.street') ?? 'optional'
}

function ruleForCarrierName(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const carrierRequirement = env.getFieldRequirement('carrier') ?? 'optional'
  if (carrierRequirement === 'forbidden') return 'forbidden'

  return 'required'
}

function ruleForCarrierAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  const carrierRequirement = env.getFieldRequirement('carrier') ?? 'optional'
  if (carrierRequirement === 'forbidden') return 'forbidden'
  if (ctx.country === 'EE') return 'required'

  return toFieldRequirement(C0053Validator.validateAddressRequirement(ctx))
}

function ruleForCarrierAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const addressRequirement = env.getFieldRequirement('carrier.address') ?? 'optional'
  if (addressRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0506Validator.validateSecurityPostcodeRequirement({
    security: ctx.security,
    country: ctx.carrier?.address?.country ?? '',
  }))
}

function ruleForCarrierAddressStreet(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  return env.getFieldRequirement('carrier.address') ?? 'optional'
}

function ruleForCarrierAddressStreetNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  return env.getFieldRequirement('carrier.address') ?? 'optional'
}

function ruleForCarrierContactPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  const carrierRequirement = env.getFieldRequirement('carrier') ?? 'optional'
  if (carrierRequirement === 'forbidden') return 'forbidden'

  return CustomValidators.validateContactPersonNameAndPhoneRequirement(ctx.carrier?.contactPerson) ? 'required' : carrierRequirement
}

function ruleForCarrierContactPersonNameAndPhoneRequirement(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const contactPersonRequirement = env.getFieldRequirement('carrier.contactPerson') ?? 'optional'
  if (contactPersonRequirement === 'forbidden') return 'forbidden'

  if (ctx.country === 'LT' && hasText(ctx.carrier?.identificationNumber)) return 'required'
  if (ctx.country === 'EE' || CustomValidators.validateContactPersonNameAndPhoneRequirement(ctx.carrier?.contactPerson)) {
    return 'required'
  }

  return contactPersonRequirement
}

function ruleForCarrierContactPersonEmail(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const contactPersonRequirement = env.getFieldRequirement('carrier.contactPerson') ?? 'optional'
  if (contactPersonRequirement === 'forbidden') return 'forbidden'

  return ctx.country === 'LT' && hasText(ctx.carrier?.identificationNumber) ? 'required' : 'optional'
}

function ruleForActiveBorderTransportMeans(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0806Validator.validateBorderTransportMeansRequirement(ctx))
}

function ruleForActiveBorderTransportMeansConveyanceReferenceNumber(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0532Validator.validateConveyanceReferenceNumberRequirement(ctx))
}

function ruleForActiveBorderTransportMeansTypeOfMeansOfTransport(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0937Validator.validateTypeOfMeansOfTransport(ctx))
}

function ruleForActiveBorderTransportMeansEstimatedDateAndTimeOfArrival(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0940Validator.validateEstimatedDateAndTimeOfArrivalRequirement(ctx))
}

function ruleForActiveBorderTransportMeansEstimatedDateAndTimeOfDeparture(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  const requirement = toFieldRequirement(
    C0071Validator.validateEstimateDateAndTimeOfDepartureRequirement({
      security: ctx.security,
      actualDateAndTimeOfDeparture: ctx.activeBorderTransportMeansItem?.actualDateAndTimeOfDeparture,
    }),
  )

  return requirement === 'forbidden' && ctx.activeBorderTransportMeansItem?.estimatedDateAndTimeOfDeparture
    ? 'optional'
    : requirement
}

function ruleForActiveBorderTransportMeansActualDateAndTimeOfDeparture(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  const requirement = toFieldRequirement(
    C0071Validator.validateActualDateAndTimeOfDepartureRequirement({
      security: ctx.security,
      estimatedDateAndTimeOfDeparture: ctx.activeBorderTransportMeansItem?.estimatedDateAndTimeOfDeparture,
    }),
  )

  return requirement === 'forbidden' && ctx.activeBorderTransportMeansItem?.actualDateAndTimeOfDeparture
    ? 'optional'
    : requirement
}

function ruleForCountryOfRoutingOfConsignment(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0586Validator.validateCountryOfRoutingRequirement(ctx))
}

function ruleForSpecificCircumstanceIndicator(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (ctx.security === '2' && ctx.country === 'LT') return 'forbidden'

  if (!ctx.isOptIn) return 'optional'

  return toFieldRequirement(C0019Validator.validateSpecificCircumstanceIndicatorRequirement(ctx))
}

function ruleForEntryIndicator(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0024Validator.validateCustomsOfficeOfDepartureEntryIndicatorRequirement(ctx))
}

function ruleForTransportEquipmentContainerSizeAndType(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0935Validator.validateContainerSizeAndTypeRequirement(ctx))
}

function ruleForTransportEquipmentPackedStatus(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0939Validator.validateContainerPackedStatus(ctx))
}

function ruleForTransportEquipmentSupplierType(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0936Validator.validateContainerSupplierTypeRequirement(ctx))
}

function ruleForConsigneeContactPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  if (!ctx.isOptIn) return 'forbidden'

  const consigneeRequirement = env.getFieldRequirement('consignee') ?? 'optional'
  if (consigneeRequirement !== 'required') return consigneeRequirement

  return toFieldRequirement(ctx.country === 'EE'
    ? CustomValidators.validateConsignmentConsigneeContactPersonRequirement(ctx)
    : C0931Validator.validateConsignmentConsigneeContactPersonRequirement(ctx))
}

function ruleForConsigneeContactPersonNameAndPhone(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const contactPersonRequirement = env.getFieldRequirement('consignee.contactPerson') ?? 'optional'
  if (contactPersonRequirement === 'forbidden') return 'forbidden'

  return CustomValidators.validateContactPersonNameAndPhoneRequirement(ctx.consignee?.contactPerson) ? 'required' : contactPersonRequirement
}

function ruleForPlaceOfAcceptance(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0932Validator.validatePlaceOfAcceptanceRequirement(ctx))
}

function ruleForPlaceOfDelivery(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0932Validator.validatePlaceOfDeliveryRequirement(ctx))
}

function ruleForDepartureTransportMeans(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0826Validator.validateDepartureTransportMeansForConsignmentRequirement(ctx))
}

function ruleForTransportDocument(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0941Validator.validateConsignmentTransportDocumentRequirement(ctx))
}

function ruleForPreviousDocumentDocumentType(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (ctx.country !== 'EE') return 'required'

  return toFieldRequirement(NA60Validator.validatePreviousDocumentDocumentTypeRequirement(ctx.previousDocument))
}

function ruleForPreviousDocumentProcedureType(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (ctx.country !== 'EE') return 'forbidden'

  const documentTypeRequirement = ruleForPreviousDocumentDocumentType(env)
  if (documentTypeRequirement === 'forbidden') return 'optional'

  return toFieldRequirement(NA60Validator.validatePreviousDocumentDocumentTypeRequirement(ctx.previousDocument))
}

function ruleForPreviousDocumentReferenceNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (ctx.country !== 'EE') return 'required'

  let requirement = toFieldRequirement(NA61Validator.validatePreviousDocumentRefNumberRequirement(ctx.previousDocument))
  if (requirement === 'optional') {
    requirement = toFieldRequirement(NA62Validator.validatePreviousDocumentReferenceNumberRequirement(ctx.previousDocument))

    if (requirement === 'forbidden' && hasText(ctx.previousDocument?.referenceNumber)) {
      requirement = 'optional'
    }
  }

  return requirement
}

function ruleForTransportChargesMethodOfPayment(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(!ctx.isOptIn
    ? C0186Validator.validateConsignmentTransportChargesRequirement(ctx)
    : C0944Validator.validateConsignmentTransportChargesRequirement(ctx))
}

const fieldRequirementResolversP6: FieldRequirementResolverMap<FieldRequirementResolverContext> = {
  activeBorderTransportMeans: ruleForActiveBorderTransportMeans,
  'activeBorderTransportMeans.*.conveyanceReferenceNumber': ruleForActiveBorderTransportMeansConveyanceReferenceNumber,
  'activeBorderTransportMeans.*.identificationNumber': required,
  'activeBorderTransportMeans.*.nationality': required,
  'activeBorderTransportMeans.*.typeOfIdentification': required,
  'activeBorderTransportMeans.*.typeOfMeansOfTransport': ruleForActiveBorderTransportMeansTypeOfMeansOfTransport,
  'activeBorderTransportMeans.*.estimatedDateAndTimeOfDeparture': ruleForActiveBorderTransportMeansEstimatedDateAndTimeOfDeparture,
  'activeBorderTransportMeans.*.actualDateAndTimeOfDeparture': ruleForActiveBorderTransportMeansActualDateAndTimeOfDeparture,
  'activeBorderTransportMeans.*.estimatedDateAndTimeOfArrival': ruleForActiveBorderTransportMeansEstimatedDateAndTimeOfArrival,
  'activeBorderTransportMeans.*.countriesOfRouting': forbidden,
  additionalDeclarationType: ruleForAdditionalDeclarationType,
  additionalInformation: forbidden,
  additionalReference: forbidden,
  authorisations: ruleForAuthorisations,
  borderModeOfTransport: ruleForBorderModeOfTransport,
  carrier: required,
  'carrier.address': ruleForCarrierAddress,
  'carrier.address.addressLine': forbidden,
  'carrier.address.postcode': ruleForCarrierAddressPostcode,
  'carrier.address.street': ruleForCarrierAddressStreet,
  'carrier.address.streetNumber': ruleForCarrierAddressStreetNumber,
  'carrier.contactPerson': ruleForCarrierContactPerson,
  'carrier.contactPerson.name': ruleForCarrierContactPersonNameAndPhoneRequirement,
  'carrier.contactPerson.telephone': ruleForCarrierContactPersonNameAndPhoneRequirement,
  'carrier.contactPerson.email': ruleForCarrierContactPersonEmail,
  'carrier.identificationNumber': required,
  'carrier.name': ruleForCarrierName,
  consignee: ruleForConsignee,
  'consignee.address': ruleForConsigneeNameAndAddress,
  'consignee.address.addressLine': ruleForConsigneeAddressAddressLine,
  'consignee.address.postcode': ruleForConsigneeAddressPostcode,
  'consignee.address.street': ruleForConsigneeAddressStreet,
  'consignee.address.streetNumber': ruleForConsigneeAddressStreetNumber,
  'consignee.id': optional,
  'consignee.identificationNumber': optional,
  'consignee.contactPerson': ruleForConsigneeContactPerson,
  'consignee.contactPerson.id': optional,
  'consignee.contactPerson.email': optional,
  'consignee.contactPerson.name': ruleForConsigneeContactPersonNameAndPhone,
  'consignee.contactPerson.telephone': ruleForConsigneeContactPersonNameAndPhone,
  'consignee.name': ruleForConsigneeNameAndAddress,
  'consignee.typeOfPerson': ruleForConsigneeTypeOfPerson,
  consignor: ruleForConsignor,
  'consignor.address': ruleForConsignorNameAndAddress,
  'consignor.address.addressLine': ruleForConsignorAddressAddressLine,
  'consignor.address.postcode': ruleForConsignorAddressPostcode,
  'consignor.address.street': ruleForConsignorAddressStreet,
  'consignor.address.streetNumber': ruleForConsignorAddressStreetNumber,
  'consignor.contactPerson': ruleForConsignorContactPerson,
  'consignor.contactPerson.id': optional,
  'consignor.contactPerson.email': ruleForConsignorContactPersonEmail,
  'consignor.contactPerson.name': ruleForConsignorContactPersonNameAndPhone,
  'consignor.contactPerson.telephone': ruleForConsignorContactPersonNameAndPhone,
  'consignor.id': optional,
  'consignor.identificationNumber': optional,
  'consignor.name': ruleForConsignorNameAndAddress,
  'consignor.typeOfPerson': ruleForConsignorTypeOfPerson,
  containerIndicator: ruleForContainerIndicator,
  countryOfRoutingOfConsignment: ruleForCountryOfRoutingOfConsignment,
  'countryOfRoutingOfConsignment.*.country': required,
  customsOfficesOfTransitExit: ruleForCustomsOfficesOfTransitExit,
  'customsOfficesOfTransitExit.*.referenceNumber': required,
  departureCustomsOffice: required,
  departureTransportMeans: ruleForDepartureTransportMeans,
  'departureTransportMeans.*.typeOfIdentification': required,
  'departureTransportMeans.*.identificationNumber': required,
  'departureTransportMeans.*.nationality': required,
  destinationCustomsOffice: required,
  entryIndicator: ruleForEntryIndicator,
  grossMass: required,
  guarantee: required,
  'guarantee.id': optional,
  'guarantee.nctsProfileId': required,
  'guarantee.amount': required,
  limitDate: ruleForLimitDate,
  locationOfGoods: ruleForLocationOfGoods,
  'locationOfGoods.authorisationNumber': ruleForLocationOfGoodsAuthorisationNumber,
  'locationOfGoods.additionalIdentifier': ruleForLocationOfGoodsAdditionalIdentifier,
  'locationOfGoods.address': ruleForLocationOfGoodsAddress,
  'locationOfGoods.address.addressLine': ruleForLocationOfGoodsAddressPart,
  'locationOfGoods.address.city': ruleForLocationOfGoodsAddressPart,
  'locationOfGoods.address.country': ruleForLocationOfGoodsAddressPart,
  'locationOfGoods.address.postcode': ruleForLocationOfGoodsAddressPostcode,
  'locationOfGoods.address.street': forbidden,
  'locationOfGoods.address.streetNumber': forbidden,
  'locationOfGoods.contactPerson': ruleForLocationOfGoodsContactPerson,
  'locationOfGoods.economicOperatorIdentificationNumber': ruleForLocationOfGoodsEconomicOperatorIdentificationNumber,
  'locationOfGoods.gnss': ruleForLocationOfGoodsGnss,
  'locationOfGoods.postcodeAddress': ruleForLocationOfGoodPostcodeAddress,
  'locationOfGoods.postcodeAddress.houseNumber': ruleForLocationOfGoodPostcodeAddressHouseNumber,
  'locationOfGoods.qualifierOfIdentification': ruleForLocationOfGoodsQualifierOfIdentification,
  'locationOfGoods.referenceNumber': ruleForLocationOfGoodsReferenceNumber,
  'locationOfGoods.typeOfLocation': ruleForLocationOfGoodsTypeOfLocation,
  'locationOfGoods.unLocode': ruleForLocationOfGoodsUnLocode,
  placeOfAcceptance: ruleForPlaceOfAcceptance,
  'placeOfAcceptance.country': required,
  'placeOfAcceptance.location': required,
  'placeOfAcceptance.unLocode': forbidden,
  placeOfDelivery: ruleForPlaceOfDelivery,
  'placeOfDelivery.country': required,
  'placeOfDelivery.location': required,
  'placeOfDelivery.unLocode': forbidden,
  placeOfUnloading: ruleForUnloading,
  'placeOfUnloading.location': required,
  'placeOfUnloading.country': required,
  'placeOfUnloading.unLocode': forbidden,
  placeOfLoading: ruleForLoading,
  'placeOfLoading.location': required,
  'placeOfLoading.country': required,
  'placeOfLoading.unLocode': forbidden,
  'previousDocument.*.documentType': ruleForPreviousDocumentDocumentType,
  'previousDocument.*.procedureType': ruleForPreviousDocumentProcedureType,
  'previousDocument.*.referenceNumber': ruleForPreviousDocumentReferenceNumber,
  referenceNumberUCR: ruleForReferenceNumberUCR,
  security: required,
  specificCircumstanceIndicator: ruleForSpecificCircumstanceIndicator,
  'supportingDocument.*.documentType': required,
  'supportingDocument.*.referenceNumber': required,
  transportEquipment: ruleForTransportEquipment,
  transitCustomsOffices: optional, // server-side should overwrite this
  'transitCustomsOffices.*.arrivalDateAndTime': ruleForTransitCustomsOfficeArrivalDateTime,
  'transitCustomsOffices.*.entryIndicator': ruleForTransitCustomsOfficeEntryIndicator,
  'transitCustomsOffices.*.reEntryIndicator': ruleForTransitCustomsOfficeReEntryIndicator,
  transportChargesMethodOfPayment: ruleForTransportChargesMethodOfPayment,
  transportDocument: ruleForTransportDocument,
  'transportDocument.*.complementOfInformation': optional,
  'transportDocument.*.documentLineNumber': optional,
  'transportDocument.*.documentType': required,
  'transportDocument.*.files': optional,
  'transportDocument.*.procedureType': optional,
  'transportDocument.*.referenceNumber': required,
  'transportDocument.*.transportDocumentReferenceNumber': optional,
  'transportEquipment.*.containerIdentificationNumber': ruleForContainerIdentificationNumber,
  'transportEquipment.*.containerSizeAndType': ruleForTransportEquipmentContainerSizeAndType,
  'transportEquipment.*.goodsReferences': ruleForGoodsReferences,
  'transportEquipment.*.goodsReferences.*.consignmentItemId': required,
  'transportEquipment.*.seals.*.identifier': required,
  'transportEquipment.*.packedStatus': ruleForTransportEquipmentPackedStatus,
  'transportEquipment.*.supplierType': ruleForTransportEquipmentSupplierType,
}

function getServerRequirementForPath(
  path: string,
  ctx: FieldRequirementResolverContext,
) {
  return matchServerRequirement(ctx.serverValidationResult?.fieldRequirements, path)
}

const getFieldRequirementP6 = createFieldRequirementGetter<FieldRequirementResolverContext>(
  fieldRequirementResolversP6,
  getServerRequirementForPath,
)

export default getFieldRequirementP6
